import { flow } from 'fp-ts/function';
import { get, has } from 'lodash/fp';
import { createSelector } from 'reselect';

import { getStringProp } from '@mews/fp';

import { parentSelector } from '../../../selectors/parentSelector';
import { getSelectedCityId } from '../../app/selectors';

export const getCities = createSelector(parentSelector, get('cities'));

// @ts-expect-error $TSFixMeError: No overload matches this call.
const getSelectedCity = createSelector(getSelectedCityId, getCities, get);

export const getSelectedCityImageId = flow(getSelectedCity, get('imageId'));
export const getSelectedCityName = flow(getSelectedCity, get('name'));

export const hasCity = createSelector(getStringProp('cityId'), getCities, has);
